
import React, {useState} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Button, Row, Col, Container, Card, InputGroup} from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Group_Master() {

  const [hdnirn, setHdnIRN] = useState('');
  const [txtGroupDesc, settxtGroupDesc] = useState('');
  const [ddlMainGrp, setDDLMainGrp] = useState('');
  const [orderPL, setOrderPL] = useState('');
  const [orderBL, setOrderBL] = useState('');
  const [schedule, setSchedule] = useState('');
  const [rdMainGrp, setRDMainGrp] = useState('0');
  const [groupData, setGroupData] = useState([]);
  const [isEditable, setIsEditable] = useState(false);

  const typeMap = {
    LIABILITIES: "1",
    ASSETS: "2",
    INCOME: "3",
    EXPENDITURE: "4",
    CONTRA: '5',
  };

  const handleRowClick = async (grpCd, grp_desc, mainGrpCd, orderPL, orderBL, schedule) => {

    try {

      var lv_MainGrpCd = '';

      if (mainGrpCd === 'LIABILITIES') {
        lv_MainGrpCd = '1';
      }
      else if (mainGrpCd === 'ASSETS') {
        lv_MainGrpCd = '2';
      }
      else if (mainGrpCd === 'INCOME') {
        lv_MainGrpCd = '3';
      }
      else if (mainGrpCd === 'EXPENDITURE') {
        lv_MainGrpCd = '4';
      }
      else if (mainGrpCd === 'CONTRA') {
        lv_MainGrpCd = '5';
      }

      setHdnIRN(grpCd);
      settxtGroupDesc(grp_desc);
      setDDLMainGrp(lv_MainGrpCd);
      setOrderBL(orderBL);
      setOrderPL(orderPL);
      setSchedule(schedule || '');
      setIsEditable(true);

    } catch (error) {
      console.error('Error fetching Level 3 group data:', error);
    }

  };

  const handleOrderPL = (e) => {

    let value = e.target.value;

    // Remove commas before validating
    value = value.replace(/,/g, "");

    // Allow only digits and at most one decimal point
    if (!/^\d*\.?\d*$/.test(value)) {
      return; // Ignore invalid input
    }

    setOrderPL(value);

  };

  const handleOrderBL = (e) => {

    let value = e.target.value;

    // Remove commas before validating
    value = value.replace(/,/g, "");

    // Allow only digits and at most one decimal point
    if (!/^\d*\.?\d*$/.test(value)) {
      return; // Ignore invalid input
    }

    setOrderBL(value);

  };

  const handleClear = () => {

    const isConfirmed = window.confirm("Sure you want to clear the record?");
    if (!isConfirmed) return;

    setHdnIRN('');
    setDDLMainGrp('0');
    settxtGroupDesc('');
    setOrderBL('');
    setOrderPL('');
    setSchedule('');
    setIsEditable(false);

  };

  const handleNewRow = () => {

    setHdnIRN('');
    setDDLMainGrp('0');
    settxtGroupDesc('');
    setOrderBL('');
    setOrderPL('');
    setSchedule('');
    setIsEditable(true);

  };

  const handleTypeRadioButton = async (e) => {

    const lv_selected_val = e.target.value;

    setRDMainGrp(lv_selected_val);
  //  var lv_MainGrpCd = '';

    // if (lv_selected_val === 'LIABILITIES') {
    //   lv_MainGrpCd = '1';
    // }
    // else if (lv_selected_val === 'ASSETS') {
    //   lv_MainGrpCd = '2';
    // }
    // else if (lv_selected_val === 'INCOME') {
    //   lv_MainGrpCd = '3';
    // }
    // else if (lv_selected_val === 'EXPENDITURE') {
    //   lv_MainGrpCd = '4';
    // }
    // else if (lv_selected_val === 'CONTRA') {
    //   lv_MainGrpCd = '5';
    // }

    setGroupData([]);

    const response = await axios.get(`${BASE_URL}/api/get_group_view`, {params : {p_MainGrpCd: e.target.value }});

    if (response.data.length > 0) {  
      setGroupData(response.data);
    }

  };

  const handleSave = async () => {

    if (!txtGroupDesc) {
      console.error("Please enter Group Desc !");
      return;
    }
    else if (ddlMainGrp === '0') {
      console.error("Please select Main Group !");
      return;
    }

    try {
      // Adjust the API endpoint and method based on your backend
      const payload = {
        grp_cd: hdnirn,
        mainGrpCd: ddlMainGrp,
        groupDesc: txtGroupDesc,
        orderPL: orderPL,
        orderBL: orderBL,
        schedule: schedule,
      };

      const isConfirmed = window.confirm("Sure you want to save the record?");
      if (!isConfirmed) return;

      const response = await axios.post(`${BASE_URL}/api/save_Groups`, payload);

      if (response.data.message === '1') {
        toast.success("Group saved successfully!");
        setIsEditable(false);
        setHdnIRN('');
        settxtGroupDesc('');
        setDDLMainGrp('0');
        setOrderBL('');
        setOrderPL('');
        setSchedule('');
        setGroupData([]);
        setRDMainGrp('');
      }


    } catch (error) {
      console.error("Error saving record:", error);
      toast.error("Failed to save Group Master.", error);
    }

  };

  return (

    <Container fluid className="p-3">

      {/* <Card className="p-3 shadow-sm" > */}
      <Card className="p-3" >

        <Row className="mb-2 ">
          <Col md={6} className="d-flex align-items-start">
            <InputGroup>
              <InputGroup.Text>Group Desc</InputGroup.Text>
              <input className="form-control" type="text"
                //style={{ marginTop: '10px' }} 
                value={txtGroupDesc}
                onChange={(e) => settxtGroupDesc(e.target.value.toUpperCase())}
                disabled={!isEditable} />
            </InputGroup>
          </Col>
          <Col md={6} className="d-flex align-items-start">
            <InputGroup>
              <InputGroup.Text>Main Group</InputGroup.Text>
              <select className="form-select"
                value={ddlMainGrp} onChange={(e) => setDDLMainGrp(e.target.value)}
                disabled={!isEditable}>
                <option value="0">Select Main Group</option>
                <option value="1">LIABILITIES</option>
                <option value="2">ASSETS</option>
                <option value="3">INCOME</option>
                <option value="4">EXPENDITURE</option>
                <option value="5">CONTRA</option>
              </select>
            </InputGroup>
          </Col>
        </Row>

        <Row className="mb-2 ">
          <Col md={3} className="d-flex align-items-start">
            <InputGroup>
              <InputGroup.Text>Order P/L</InputGroup.Text>
              <input className="form-control text-end" type="text"
                value={orderPL} 
                onChange={handleOrderPL}
                disabled={!isEditable} />
            </InputGroup>
          </Col>
          <Col md={3} className="d-flex align-items-start">
            <InputGroup>
              <InputGroup.Text>Order B/L</InputGroup.Text>
              <input className="form-control text-end" type="text"
                value={orderBL}
                onChange={handleOrderBL}
                disabled={!isEditable} />
            </InputGroup>
          </Col>

          <Col md={3} className="d-flex align-items-start">
            <InputGroup>
              <InputGroup.Text>Schedule</InputGroup.Text>
              <input className="form-control" type="text"
                value={schedule}
                onChange={(e) => setSchedule(e.target.value.toUpperCase())}
                disabled={!isEditable} />
            </InputGroup>
          </Col>

          <Col md={3} className="d-flex justify-content-end">
            <Button variant="primary" className="me-2" style={{width: "100px"}} disabled={isEditable} onClick={handleNewRow}>New</Button>
            <Button variant="secondary" className="me-2" style={{width: "100px"}} onClick={handleClear}>Clear </Button>
            <Button variant="success" className="me-2" style={{width: "100px"}} onClick={handleSave} disabled={!isEditable}>Save</Button>
          </Col>
        </Row>

      </Card>

      <Card className="p-3 shadow-sm" style={{ marginTop: '10px' }}>

        <Row className="mb-3">
          <Col md={12} className="d-flex align-items-center">
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>Main Group</InputGroup.Text>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #ced4da",
                  borderLeft: "0",                 // <-- joins seamlessly with InputGroup.Text
                  //borderRadius: "0.375rem",        // Bootstrap default radius
                  borderRadius: "0 0.375rem 0.375rem 0",
                  //  padding: "0 12px",               // match input height
                  gap: "15px",
                  height: "100%",                  // match height of InputGroup.Text
                  padding: "0.375rem 0.75rem",  // SAME as InputGroup.Text
                  lineHeight: "1.5",
                }}
              //style={{margin: '10px'}}
              >
                {Object.keys(typeMap).map((type) => (
                  <label key={type} className="me-3" style={{ marginBottom: 0 }}>
                    <input
                      type="radio"
                      style={{ marginRight: "4px" }}
                      name="rdMainGrp"
                      value={typeMap[type]}       // <-- stored value (G, A, S, M)
                      checked={rdMainGrp === typeMap[type]}
                      onChange={handleTypeRadioButton}
                      //onChange={(e) => setNoticeType(e.target.value)}
                    />
                    {type}
                  </label>
                ))}
              </div>
            </InputGroup>
          </Col>
        </Row>

        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table">
            {/* style={{ width: '800px', height: '100%', minHeight: '100px' }}> */}
            <thead>
              <tr>
                <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', display: 'none' }}>irn</th>
                <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '35%' }}>Group Desc</th>
                <th style={{ textAlign: 'center', background: 'lightblue', color: 'black', width: '10%' }}>Main Group</th>
                <th style={{ textAlign: 'right', background: 'lightblue', color: 'black', width: '5%' }}>Order PL</th>
                <th style={{ textAlign: 'right', background: 'lightblue', color: 'black', width: '5%' }}>Order BL</th>
                <th style={{ textAlign: 'center', background: 'lightblue', color: 'black', width: '5%' }}>Schedule</th>
              </tr>
            </thead>
            <tbody>
              {groupData.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center' }}>No Group Found</td>
                </tr>
              ) : (
                groupData.map((item, index) => (
                  <tr key={index} onClick={() => handleRowClick(item.grp_cd, item.grp_desc, item.main_grp_desc, item.order_pl, item.order_bl, item.schedule)}
                   style={{ cursor: 'pointer', height: '40px' }}>
                    <td style={{ display: 'none' }}>{item.grp_cd}</td>
                    <td style={{ textAlign: 'left'}}>{item.grp_desc}</td>
                    <td style={{ textAlign: 'center'}}>{item.main_grp_desc}</td>
                    <td style={{ textAlign: 'right'}}>{item.order_pl}</td>
                    <td style={{ textAlign: 'right'}}>{item.order_bl}</td>
                    <td style={{ textAlign: 'center'}}>{item.schedule}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </Card>

    </Container>
  )
}

export default Group_Master;
